// import Vue from 'vue'
import Router from 'vue-router'
import frontFrame from '@c/FrontFrame.vue'
import qrGenerate from '@c/generate/qrGenerate.vue'
import qrIDcard from '@c/generate/qrIDcard.vue'
import qrIDcardshow from '@c/generate/qrIDcardshow.vue'
import qrText from '@c/generate/qrText.vue'
import qrUrl from '@c/generate/qrUrl.vue'
import qrWechat from '@c/generate/qrWechat.vue'
import homepage from '@c/Homepage.vue'
import mainRouter from '@c/mainRouter.vue'
import manageFrame from '@c/manageFrame.vue'
import NotFound from '@c/NotFound.vue'
import aboutus from '@c/poster/aboutus.vue'
import cases from '@c/poster/cases.vue'
import help from '@c/poster/help.vue'
import idCardQr from '@c/poster/idCardQr.vue'
import outtime from '@c/poster/outTime.vue'
import price from '@c/poster/priceOffline.vue'
import qrNotFound from '@c/poster/qrNotFound.vue'
import scanNumberExceed from '@c/poster/scanNumberExceed.vue'
import tempQr from '@c/poster/tempQr.vue'
import terms from '@c/poster/terms.vue'
import dataAnalysisContent from '@c/qrmanage/dataAnalysis/dataAnalysisContent.vue'
import qrScanningScanAnalysis from '@c/qrmanage/dataAnalysis/qrScanningScanAnalysis.vue'
import qrScanningTotalAnalysis from '@c/qrmanage/dataAnalysis/qrScanningTotalAnalysis.vue'
import selectQrInfoList from '@c/qrmanage/dataAnalysis/selectQrInfoList.vue'
import feedback from '@c/qrmanage/feedback/feedback.vue'
import labelManageContent from '@c/qrmanage/labelManage/labelManageContent.vue'
import qrInfoList from '@c/qrmanage/labelManage/qrInfoList.vue'
import security from '@c/qrmanage/security/security.vue'
import userMessage from '@c/qrmanage/userMessage/userMessage.vue'
import source from '@c/source/source.vue'
import text from '@c/text/editText.vue'
import forgotPassword from '@c/user/login/forgotPassword.vue'
import forgotpasswordEmailConfirmPrompt from '@c/user/login/forgotpasswordEmailConfirmPrompt.vue'
import resetPassword from '@c/user/login/resetPassword.vue'
import userLoginPage from '@c/user/login/userLoginPage.vue'
import registerAccountActivate from '@c/user/register/registerAccountActivate.vue'
import registerEmailConfirmPrompt from '@c/user/register/registerEmailConfirmPrompt.vue'
import registerResendMailPage from '@c/user/register/registerResendMailPage.vue'
import userRegisterPage from '@c/user/register/userRegisterPage.vue'
import audioPage from './views/audioPage.vue'
// Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: mainRouter,
      children: [
        {
          path: '',
          component: frontFrame,
          children: [
            {
              path: '',
              alias: 'index.html',
              name: 'homepage',
              component: homepage
            },
            {
              path: 'qrgenerate',
              component: qrGenerate,
              children: [
                {
                  path: '',
                  redirect: 'url'
                },
                {
                  path: 'url',
                  name: 'qrUrl',
                  component: qrUrl
                },
                {
                  path: 'text',
                  name: 'qrText',
                  component: qrText
                },
                {
                  path: 'wechat',
                  name: 'qrWechat',
                  component: qrWechat
                },
                {
                  path: 'qrIDcard',
                  name: 'qrIDcard',
                  component: qrIDcard
                },
                {
                  path: 'qrIDcardshow',
                  name: 'qrIDcardshow',
                  component: qrIDcardshow
                }
              ]
            },
            {
              // 用户登录页面
              path: 'user/login',
              name: 'userLoginPage',
              component: userLoginPage
            },
            {
              // 用户注册界面
              path: 'user/register',
              name: 'userRegisterPage',
              component: userRegisterPage
            },
            {
              // 重新发送激活邮件的页面
              path: 'user/register/resend',
              name: 'registerResendMailPage',
              component: registerResendMailPage
            },
            {
              // 提醒用户查收注册邮件的页面
              path: 'user/register/resendPrompt',
              name: 'registerEmailConfirmPrompt',
              component: registerEmailConfirmPrompt
            },
            {
              path: 'user/register/confirm/:token',
              name: 'registerAccountActivate',
              component: registerAccountActivate
            },
            {
              path: 'user/forgotpassword',
              name: 'forgotPassword',
              component: forgotPassword
            },
            {
              path: 'user/forgotpassword/prompt',
              name: 'forgotpasswordEmailConfirmPrompt',
              component: forgotpasswordEmailConfirmPrompt
            },
            {
              path: 'user/login/resetpassword/:email/:token',
              name: 'resetPassword',
              component: resetPassword
            },
            // poser
            {
              path: 'terms',
              name: 'terms',
              component: terms
            },
            {
              path: 'price',
              name: 'price',
              component: price
            },
            {
              path: 'cases',
              name: 'cases',
              component: cases
            },
            {
              path: 'aboutus',
              name: 'aboutus',
              component: aboutus
            },
            {
              path: 'help',
              component: help
            },
            {
              path: '/source/:id',
              component: source
            }
            // {
            //   path: '/charts',
            //   name: 'charts',
            //   component: charts
            // }
          ]
        },
        {
          path: '/qrmanage',
          component: manageFrame,
          children: [
            {
              path: '',
              redirect: '/labelManage'
            },
            {
              path: '/labelManage', // 标签管理
              component: labelManageContent,
              children: [
                {
                  // all
                  path: '',
                  // component: allQRList
                  redirect: 'labelid/all/n/10/p/1'
                },
                {
                  path: 'labelid/:id',
                  redirect: 'labelid/:id/n/10/p/1'
                },
                {
                  path: 'labelid/:id/n/:num/p/:page',
                  name: 'qrInfoList',
                  component: qrInfoList
                }
              ]
            },
            {
              path: '/announcement', // 公告
              component: () => import('@c/qrmanage/announcement/announcementContent.vue')
            },
            {
              path: '/userMessage',
              component: userMessage
            },
            {
              path: '/security',
              component: security
            },
            {
              path: '/feedback',
              component: feedback
            },
            {
              path: '/analysis',
              component: dataAnalysisContent,
              children: [
                {
                  path: '',
                  redirect: 'total'
                },
                {
                  path: 'scan',
                  name: 'qrScanningScanAnalysis',
                  component: qrScanningScanAnalysis,
                  children: [
                    {
                      path: 'labelid/:id',
                      redirect: 'labelid/:id/n/5/p/1'
                    },
                    {
                      path: 'labelid/:id/n/:num/p/:page/',
                      name: 'selectQrInfoList',
                      component: selectQrInfoList
                    }
                  ]
                },
                {
                  path: 'total',
                  name: 'qrScanningTotalAnalysis',
                  component: qrScanningTotalAnalysis
                }
              ]
            },
            {
              path: '/wechat_page_track/qr/:qrid/track_code/:track_code',
              component: () => import('@c/qrmanage/wechatPages/wechatTrackByCode.vue')
            },
            {
              path: '/wechat_page_track/page/:page/num/:num',
              component: () => import('@c/qrmanage/wechatPages/wechatTrackOfOwner.vue')
            }
          ]
        }
      ]
    },
    {
      path: '/audio/:audioResourceId',
      component: audioPage
    },
    {
      path: '/outtime',
      component: outtime
    },
    {
      path: '/qrNotFound',
      component: qrNotFound
    },
    {
      path: '/scanNumberExceed',
      component: scanNumberExceed
    },
    {
      path: '/tempQr',
      component: tempQr
    },
    {
      path: '/editText',
      component: text
    },
    {
      path: '/idCardQr',
      component: idCardQr
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})
